import React from 'react'
import Productreviewcard from './Productreviewcard';
import '../styles/Productreview.css'

const Productreview = (props) => {
    console.log("product reviews",props.productreviews);
    return (
    <>
      <div className="Productreview">
         {
           props.productreviews.map((item,index)=>{
             return(
                // <div className="Productreview1">
              <Productreviewcard price={item.price} name={item.name} image={item.image} review={item.review} index={index}></Productreviewcard>
                // </div>
             )
           })
         } 
      </div>        
    </>
    )
}

export default Productreview
